const config = {
    403: {
        img: '/404-GIF-error.gif',
        title: '403',
        desc: 'Sorry, you do not have access to the page\n'
    },
    404: {
        img: '/404-GIF-error.gif',
        title: '404',
        desc: 'Sorry, the page you visited does not exist.\n'
    },
    500: {
        img: '/404-GIF-error.gif',
        title: '500',
        desc: 'Sorry, there is a server error.'
    }
}

export default config
